module.exports = __webpack_public_path__ + "static/media/tl.540973db.png";